export default {
  permissions: {
    search: [{ name: 'search', type: 'text' }],
    create: [{ name: 'permission', type: 'name' }],
  },

  accounts: {
    search: [{ name: 'search', type: 'text' }],
  },

  users: {
    search: [{ name: 'search', type: 'text' }],
    create: [{ name: 'email', label: 'Email', type: 'email' }],
  },

  vehicles: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'registration', label: 'Registration', type: 'text' },
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
      { name: 'manufacture_date', label: 'Manufacture Date', type: 'date' },
      { name: 'mileage', label: 'Mileage', type: 'number' },
      { name: 'service_mileage', label: 'Service Mileage', type: 'number' },
      { name: 'mot_date', label: 'MOT Date', type: 'date' },
      { name: 'condition', label: 'Condition', type: 'select' },
      { name: 'insured', label: 'Insured', type: 'select' },
    ],
    update: [
      { name: 'registration', label: 'Registration', type: 'text' },
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
      { name: 'manufacture_date', label: 'Manufacture Date', type: 'date' },
      { name: 'mileage', label: 'Mileage', type: 'number' },
      { name: 'service_mileage', label: 'Service Mileage', type: 'number' },
      { name: 'mot_date', label: 'MOT Date', type: 'date' },
      { name: 'condition', label: 'Condition', type: 'select' },
      { name: 'insured', label: 'Insured', type: 'select' },
    ],
    service: [
      { name: 'mileage', label: 'Mileage', type: 'number' },
      { name: 'type', label: 'Type', type: 'select' },
    ],
  },

  vehicleTypes: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'website_slug', label: 'Website Slug', type: 'text' },
      { name: 'full_name', label: 'Full Name', type: 'text' },
      { name: 'image', label: 'Image', type: 'file' },
      { name: 'one_to_two_days', label: 'Price: 1 - 2 Days', type: 'text' },
      { name: 'three_to_six_days', label: 'Price: 3 - 6 Days', type: 'text' },
      { name: 'seven_days', label: 'Price: 7+ days', type: 'text' },
    ],
    update: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'website_slug', label: 'Website Slug', type: 'text' },
      { name: 'full_name', label: 'Full Name', type: 'text' },
      { name: 'image', label: 'Replace Image', type: 'file' },
      { name: 'size', label: 'Size', type: 'number' },
      { name: 'Pricing', type: 'section' },
      { name: 'one_to_two_days', label: 'Price: 1 - 2 Days', type: 'text' },
      { name: 'three_to_six_days', label: 'Price: 3 - 6 Days', type: 'text' },
      { name: 'seven_days', label: 'Price: 7+ days', type: 'text' },
    ],
  },

  companies: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'phone_number', label: 'Phone Number', type: 'text' },
    ],
    updateGeneric: [
      { name: 'name', label: 'Name*', type: 'text' },
      { name: 'phone_number', label: 'Phone Number*', type: 'text' },
    ],
    updateContact: [
      { name: 'Contact Details', type: 'section' },
      {
        name: 'general_contact_name',
        label: 'General Contact Name',
        type: 'text',
      },
      {
        name: 'general_contact_email',
        label: 'General Contact Email',
        type: 'text',
      },
      {
        name: 'accounts_contact_name',
        label: 'Accounts Contact Name',
        type: 'text',
      },
      {
        name: 'accounts_contact_email',
        label: 'Accounts Contact Email',
        type: 'text',
      },
    ],
    updateInsurance: [
      { name: 'Insurance Details', type: 'section' },
      {
        name: 'pay_own_insurance',
        label: 'Pays Own Insurance?',
        type: 'select',
      },
      {
        name: 'insurer',
        label: 'Insurer',
        type: 'text',
        filter(_, data) {
          return data.data && Number(data.data.pay_own_insurance) !== 1;
        },
      },
      {
        name: 'policy_number',
        label: 'Policy number',
        type: 'text',
        filter(_, data) {
          return data.data && Number(data.data.pay_own_insurance) !== 1;
        },
      },
      {
        name: 'expiry_date',
        label: 'Insurance expiry date',
        type: 'date',
        filter(_, data) {
          return data.data && Number(data.data.pay_own_insurance) !== 1;
        },
      },
    ],
    updateAccount: [
      { name: 'Account Details', type: 'section' },
      {
        name: 'has_account',
        label: 'Has account',
        type: 'select',
      },
      {
        name: 'account_type',
        label: 'Type',
        type: 'select',
        filter(_, data) {
          return data.data && Number(data.data.has_account) !== 1;
        },
      },
      {
        name: 'account_card_expiry',
        label: 'Card Expiry Date',
        type: 'date',
        filter(_, data) {
          return (
            (data.data && data.data.account_type !== 'END_OF_HIRE') ||
            Number(data.data.has_account) !== 1
          );
        },
      },
      {
        name: 'account_online_bypass',
        label: 'Online Bypass',
        type: 'select',
        filter(_, data) {
          return data.data && Number(data.data.has_account) !== 1;
        },
      },
    ],
  },

  drivers: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'first_name', label: 'First Name*', type: 'text' },
      { name: 'middle_name', label: 'Middle Name', type: 'text' },
      { name: 'last_name', label: 'Last Name*', type: 'text' },
      { name: 'phone_number', label: 'Phone Number*', type: 'text' },
    ],
    updateGeneric: [
      { name: 'first_name', label: 'First Name*', type: 'text' },
      { name: 'middle_name', label: 'Middle Name', type: 'text' },
      { name: 'last_name', label: 'Last Name*', type: 'text' },
      {
        name: 'reputation',
        label: 'Reputation*',
        type: 'select',
      },
      { name: 'date_of_birth', label: 'Date of Birth*', type: 'date' },
    ],
    updateContact: [
      { name: 'Contact Details', type: 'section' },
      { name: 'phone_number', label: 'Phone Number*', type: 'text' },
      { name: 'email', label: 'Email Address', type: 'text' },
      { name: 'Company Details', type: 'section' },
      { name: 'occupation', label: 'Occupation*', type: 'text' },
    ],
    updateLegal: [
      { name: 'License Details', type: 'section' },
      {
        name: 'driving_license_number',
        label: 'Driving License Number*',
        type: 'text',
      },
      { name: 'pass_date', label: 'License Pass Date*', type: 'date' },
      { name: 'expiry_date', label: 'License Expiry Date*', type: 'date' },
      { name: 'Insurance', type: 'section' },
      {
        name: 'convictions_1',
        label:
          'Have they had any motoring convictions\
        in the last 5 years or are there any prosecutions pending or police\
        enquiries outstanding (including fixed penalty offences)?',
        type: 'select',
      },
      {
        name: 'convictions_2',
        label:
          'Have they had any criminal convictions\
        (or been charged with a criminal offence but not yet tried)?',
        type: 'select',
      },
      {
        name: 'convictions_3',
        label:
          'If yes for any convictions, provide names, offences, dates, penalties and\
        points for convictions',
        type: 'textarea',
        filter(field, data) {
          return (
            data.data &&
            Number(data.data.convictions_1) !== 1 &&
            Number(data.data.convictions_2) !== 1
          );
        },
      },
      {
        name: 'accidents',
        label:
          'Have there been any accidents, thefts or\
        losses (whether covered by insurance or not and regardless of blame)\
        during the past 3 years in connection with any vehicle owned, driven\
        or in the charge of you?',
        type: 'select',
      },
      {
        name: 'accidents_years',
        label: 'Years of accidents',
        type: 'text',
        filter(field, data) {
          return data.data && Number(data.data.accidents) !== 1;
        },
      },
      {
        name: 'accidents_total_number',
        label: 'Total number of accidents, thefts, or losses',
        type: 'number',
        filter(field, data) {
          return data.data && Number(data.data.accidents) !== 1;
        },
      },
      {
        name: 'accidents_total_cost',
        label: 'Total cost of the losses, and settled claims',
        type: 'number',
        step: 0.01,
        filter(field, data) {
          return data.data && Number(data.data.accidents) !== 1;
        },
      },
      {
        name: 'accidents_outstanding_number',
        label: 'Number of outstanding losses and claims',
        type: 'number',
        filter(field, data) {
          return data.data && Number(data.data.accidents) !== 1;
        },
      },
      {
        name: 'accidents_outstanding_cost',
        label: 'Estimated cost of outstanding losses and claims',
        type: 'number',
        step: 0.01,
        filter(field, data) {
          return data.data && Number(data.data.accidents) !== 1;
        },
      },
      {
        name: 'defects',
        label:
          'Have they defective vision or hearing (not\
        correct by glasses or hearing aid), any physical, mental, alcoholic\
        or nervous disorder, or heart, diabetic or epileptic condition or\
        other complaints, had blackouts or fits or regularly take any prescribed\
        medication?',
        type: 'select',
      },
      {
        name: 'defect_details',
        label: 'If yes, give full details',
        type: 'textarea',
        filter(field, data) {
          return data.data && Number(data.data.defects) !== 1;
        },
      },
    ],
  },

  holidays: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'description', label: 'Description', type: 'textarea' },
    ],
    update: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'description', label: 'Description', type: 'textarea' },
    ],
  },

  reservations: {
    create: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'vehicle_id', label: 'Vehicle', type: 'select' },
      { name: 'type', label: 'Type', type: 'select' },
      { name: 'condition', label: 'Condition', type: 'select' },
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'description', label: 'Description', type: 'textarea' },
    ],
    update: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'vehicle_id', label: 'Vehicle', type: 'select' },
      { name: 'type', label: 'Type', type: 'select' },
      { name: 'condition', label: 'Condition', type: 'select' },
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'description', label: 'Description', type: 'textarea' },
    ],
  },

  notes: {
    normal: [
      { name: 'text', type: 'textarea' },
      { name: 'resolveable', label: 'Can this be resolved?', type: 'checkbox' },
    ],
    withAssignee: [
      { name: 'text', type: 'textarea' },
      { name: 'resolveable', label: 'Can this be resolved?', type: 'checkbox' },
      { name: 'new_assignee', label: 'Add assignee', type: 'select' },
    ],
  },

  accessories: {
    search: [{ name: 'search', type: 'text' }],
    create: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'image', label: 'Image', type: 'file' },
      { name: 'limit', label: 'Limit (0: No limit)', type: 'number' },
      { name: 'price', label: 'Price (£)', type: 'text' },
      { name: 'per_day', label: 'Per Day?', type: 'checkbox' },
      { name: 'per_driver', label: 'Per Driver?', type: 'checkbox' },
    ],
    update: [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'image', label: 'Replace Image', type: 'file' },
      { name: 'limit', label: 'Limit (0: No limit)', type: 'number' },
      { name: 'featured', label: 'Featured', type: 'checkbox' },
      { name: 'Pricing', type: 'section' },
      { name: 'price', label: 'Price (£)', type: 'text' },
      {
        name: 'additional_daily_price',
        label: 'Additional daily charge (£)',
        type: 'text',
      },
      {
        name: 'additional_weekly_price',
        label: 'Additional weekly charge (£)',
        type: 'text',
      },
      { name: 'per_day', label: 'Per Day?', type: 'checkbox' },
      { name: 'per_driver', label: 'Per Driver?', type: 'checkbox' },
    ],
  },

  bookings: {
    create: [
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'start_time', label: 'Collection Time', type: 'select' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
    ],
    updatePendingHire: [
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'start_time', label: 'Collection Time', type: 'select' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
      { name: 'company_id', label: 'Company', type: 'select' },
      {
        name: 'hire_cost_per_day',
        label: 'Hire Cost Per Day (£)',
        type: 'text',
      },
    ],
    updateCollection: [
      { name: 'start_date', label: 'Start Date', type: 'date' },
      { name: 'start_time', label: 'Collection Time', type: 'select' },
      { name: 'end_date', label: 'End Date', type: 'date' },
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
      { name: 'company_id', label: 'Company', type: 'select' },
    ],
    updateHire: [
      { name: 'end_date', label: 'End Date', type: 'date' },
      {
        name: 'hire_cost_per_day',
        label: 'Hire Cost Per Day (£)',
        type: 'text',
      },
    ],
    updateDrivers: [
      {
        name: 'additional_driver_cost',
        label: 'Additional Driver Cost (£)',
        type: 'text',
      },
    ],
    updatePricing: [
      { name: 'security_cost', label: 'Security Cost (£)', type: 'text' },
      { name: 'discount', label: 'Discount (£)', type: 'text' },
      { name: 'discount_note', label: 'Discount Note', type: 'text' },
      { name: 'order_number', label: 'Order Number', type: 'text' },
      {
        name: 'responsibility_amount',
        label: 'Responsibility Amount',
        type: 'number',
        step: 0.01,
      },
    ],
    updateCollectionPricing: [
      { name: 'security_cost', label: 'Security Cost (£)', type: 'text' },
      { name: 'discount', label: 'Discount (£)', type: 'text' },
      { name: 'discount_note', label: 'Discount Note', type: 'text' },
      { name: 'order_number', label: 'Order Number', type: 'text' },
      {
        name: 'responsibility_amount',
        label: 'Responsibility Amount',
        type: 'number',
        step: 0.01,
      },
      {
        name: 'hire_cost_per_day',
        label: 'Hire Cost Per Day (£)',
        type: 'text',
      },
      {
        name: 'additional_driver_cost',
        label: 'Additional Driver Cost (£)',
        type: 'text',
      },
    ],
    assign: [
      { name: 'vehicle_id', label: 'Vehicle', type: 'select' },
      { name: 'mileage', label: 'Mileage', type: 'text' },
    ],
    collection: [
      { name: 'vehicle_type_id', label: 'Vehicle Type', type: 'select' },
      {
        name: 'hire_cost_per_day',
        label: 'Hire Cost Per Day (£)',
        type: 'text',
      },
      {
        name: 'additional_driver_cost',
        label: 'Cost Per Additional Driver (£)',
        type: 'text',
      },
      { name: 'company_id', label: 'Company', type: 'select' },
      {
        name: 'extra_mileage_rate',
        label: 'Cost Per Extra Mile (£)',
        type: 'text',
      },
      { name: 'order_number', label: 'Order Number', type: 'text' },
      { name: 'security_cost', label: 'Security Cost (£)', type: 'text' },
      { name: 'discount', label: 'Discount (£)', type: 'text' },
      { name: 'discount_note', label: 'Discount Note', type: 'text' },
    ],
    finalForm: [
      {
        name: 'hire_cost_per_day',
        label: 'Hire Cost Per Day (£)',
        type: 'text',
      },
      { name: 'return_date', label: 'Return Date', type: 'date' },
      { name: 'mileage_after', label: 'Mileage After', type: 'text' },
      {
        name: 'extra_mileage_rate',
        label: 'Cost Per Extra Mile (£)',
        type: 'text',
      },
    ],
  },

  bankingExport: {
    search: [{ name: 'search', type: 'text' }],
  },

  payments: {
    normal: [{ label: 'Amount', name: 'total', type: 'number', step: 0.01 }],
    updatePayment: [
      { name: 'total', label: 'Total* (£)', type: 'text' },
      { name: 'type', label: 'Type*', type: 'select' },
      { name: 'origin', label: 'Origin*', type: 'select' },
    ],
  },

  settings: [
    {
      label: 'Default Responsibility Amount',
      name: 'default_responsibility_amount',
      type: 'number',
      step: 0.01,
    },
    {
      label: 'Price Per Mile',
      name: 'price_per_mile',
      type: 'number',
      step: 0.01,
    },
    {
      label: 'Security Cost',
      name: 'security_cost',
      type: 'number',
      step: 0.01,
    },
    {
      label: 'Terms & Conditions (Markdown supported)',
      name: 'terms_conditions',
      type: 'textarea',
    },
  ],
};
